import _toConsumableArray from "/codebuild/output/src145264479/src/LandingPage/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React, { forwardRef, Children } from 'react';
import { useComponentDefaultProps, rem } from '@mantine/styles';
import { packSx } from '@mantine/utils';
import { TimelineItem } from './TimelineItem/TimelineItem.js';
import useStyles from './Timeline.styles.js';
import { Box } from '../Box/Box.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var defaultProps = {
  active: -1,
  radius: "xl",
  bulletSize: 20,
  align: "left",
  lineWidth: 4,
  reverseActive: false
};
var Timeline = forwardRef(function (props, ref) {
  var _a = useComponentDefaultProps("Timeline", defaultProps, props),
    className = _a.className,
    children = _a.children,
    active = _a.active,
    color = _a.color,
    radius = _a.radius,
    bulletSize = _a.bulletSize,
    align = _a.align,
    lineWidth = _a.lineWidth,
    classNames = _a.classNames,
    styles = _a.styles,
    sx = _a.sx,
    reverseActive = _a.reverseActive,
    unstyled = _a.unstyled,
    variant = _a.variant,
    others = __objRest(_a, ["className", "children", "active", "color", "radius", "bulletSize", "align", "lineWidth", "classNames", "styles", "sx", "reverseActive", "unstyled", "variant"]);
  var _useStyles = useStyles(null, {
      name: "Timeline",
      classNames: classNames,
      styles: styles,
      unstyled: unstyled,
      variant: variant
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var _children = Children.toArray(children);
  var items = _children.map(function (item, index) {
    return React.cloneElement(item, {
      variant: variant,
      classNames: classNames,
      styles: styles,
      align: align,
      lineWidth: lineWidth,
      radius: item.props.radius || radius,
      color: item.props.color || color,
      bulletSize: item.props.bulletSize || bulletSize,
      unstyled: unstyled,
      active: item.props.active || (reverseActive ? active >= _children.length - index - 1 : active >= index),
      lineActive: item.props.lineActive || (reverseActive ? active >= _children.length - index - 1 : active - 1 >= index)
    });
  });
  var offset = align === "left" ? {
    paddingLeft: "calc(".concat(rem(bulletSize), " / 2 + ").concat(rem(lineWidth), " / 2)")
  } : {
    paddingRight: "calc(".concat(rem(bulletSize), " / 2 + ").concat(rem(lineWidth), " / 2)")
  };
  return /* @__PURE__ */React.createElement(Box, __spreadValues({
    className: cx(classes.root, className),
    ref: ref,
    sx: [offset].concat(_toConsumableArray(packSx(sx)))
  }, others), items);
});
Timeline.Item = TimelineItem;
Timeline.displayName = "@mantine/core/Timeline";
export { Timeline };